export class JobStatusReasonType {
    readonly reasonId: number;
    readonly agentDescription: string;
    readonly clientDescription?: string;

    constructor(
        reasonId: number,
        agentDescription: string,
        clientDescription?: string
    ) {
        this.reasonId = reasonId;
        this.agentDescription = agentDescription;
        this.clientDescription = clientDescription;
    }

    public static NoStatusReason = new JobStatusReasonType(
        0,
        "[no status reason]"
    );

    //open reasons
    public static OpenAcceptingBackupCandidates = new JobStatusReasonType(
        10,
        "The client is reviewing submissions, but we are open to backup candidates.",
        "This job is accepting backup candidates."
    );
    public static OpenUpdatedDetails = new JobStatusReasonType(
        30,
        "This job has new rates, requirements or is re-opened.",
        "This job has updated requirements."
    );
    public static OpenUrgent = new JobStatusReasonType(
        40,
        "This job is a priority for the client.",
        "This job is a priority for Relode."
    );
    public static OpenEvergreen = new JobStatusReasonType(
        50,
        "This job is an ongoing need for the client.",
        "This job has updated requirements."
    );

    //pause reasons
    public static PausedOfferNegotiation = new JobStatusReasonType(
        110,
        "This job is paused as there is a candidate in offer negotiations.",
        "This job is paused due to current candidate negotiations."
    );
    public static PausedReconsideringNeed = new JobStatusReasonType(
        140,
        "This job is paused due to budget uncertainty.",
        "This job is paused due to budget re-evaluation."
    );
    public static PausedRequalifying = new JobStatusReasonType(
        150,
        "This job is paused while Relode collects additional details from the client.",
        "This job is paused as Relode needs additional details from your team."
    );
    public static PausedClientUnresponsive = new JobStatusReasonType(
        170,
        "This job is paused as the client is being unresponsive.",
        "We have paused this job due to your lack of response."
    );

    //close reasons
    public static ClosedRelodeHire = new JobStatusReasonType(
        210,
        "This job was filled by Relode.",
        "This job was filled by Relode."
    );
    public static ClosedNotNeeded = new JobStatusReasonType(
        220,
        "The client indicated that this job is no longer needed.",
        "Your team indicated that this job is no longer needed."
    );
    public static ClosedOutsideHire = new JobStatusReasonType(
        230,
        "This job was filled outside of Relode.",
        "This job was filled outside of Relode."
    );
    public static ClosedAbandoned = new JobStatusReasonType(
        240,
        "This job was closed due to lack of client feedback.",
        "This job was closed as no feedback was provided."
    );

    //integration
    public static Integration = new JobStatusReasonType(
        310,
        "This job was closed via automated integration.",
        "This job was closed via automated integration."
    );

    public static OpenReasons: JobStatusReasonType[] = [
        JobStatusReasonType.NoStatusReason,
        JobStatusReasonType.OpenAcceptingBackupCandidates,
        JobStatusReasonType.OpenUpdatedDetails,
        JobStatusReasonType.OpenUrgent,
        JobStatusReasonType.OpenEvergreen,
    ];

    public static PauseReasons: JobStatusReasonType[] = [
        JobStatusReasonType.PausedOfferNegotiation,
        JobStatusReasonType.PausedReconsideringNeed,
        JobStatusReasonType.PausedRequalifying,
        JobStatusReasonType.PausedClientUnresponsive,
    ];

    public static CloseReasons: JobStatusReasonType[] = [
        JobStatusReasonType.ClosedRelodeHire,
        JobStatusReasonType.ClosedNotNeeded,
        JobStatusReasonType.ClosedOutsideHire,
        JobStatusReasonType.ClosedAbandoned,
    ];

    public static asArray = () => [
        JobStatusReasonType.NoStatusReason,
        JobStatusReasonType.OpenAcceptingBackupCandidates,
        JobStatusReasonType.OpenUpdatedDetails,
        JobStatusReasonType.OpenUrgent,
        JobStatusReasonType.OpenEvergreen,
        JobStatusReasonType.PausedOfferNegotiation,
        JobStatusReasonType.PausedReconsideringNeed,
        JobStatusReasonType.PausedRequalifying,
        JobStatusReasonType.PausedClientUnresponsive,
        JobStatusReasonType.ClosedRelodeHire,
        JobStatusReasonType.ClosedNotNeeded,
        JobStatusReasonType.ClosedOutsideHire,
        JobStatusReasonType.ClosedAbandoned,
    ];

    public static fromId = (id: number) => {
        if (id === undefined) return undefined;
        const status = JobStatusReasonType.asArray().find(
            s => s.reasonId === id
        );
        return status;
    };
}
